import { Edit, Trash } from "iconsax-reactjs";
import Button from "../../commons/Button";
import type { Banner } from "../../../services/webServices/banner/types";

type BannerCarouselItemProps = {
  banner: Banner;
  onEdit: (video: Banner) => void;
  onDelete: (uuid: string) => void;
};

export default function BannerCarouselItem({ banner, onEdit, onDelete }: BannerCarouselItemProps) {

  const handleDelete = () => {
    const confirmed = window.confirm("آیا از حذف این بنر مطمئن هستید؟");
    if (!confirmed) return;
    onDelete(banner.uuid);
  };

  return (
    <div className="relative w-72 bg-white rounded-2xl shadow-md flex-shrink-0 overflow-hidden">
      <div className="absolute top-3 right-3 z-20 flex gap-2 transition-opacity duration-300">
        <Button
          variant="neutral"
          style="solid"
          size="md"
          text=""
          loading={false}
          disabled={false}
          onClick={handleDelete}
          icon={Trash}
          customClassName="shadow-[0_0_10px_rgba(0,0,0,0.25)]"
        />

        <Button
          variant="neutral"
          style="solid"
          size="md"
          text=""
          loading={false}
          disabled={false}
          onClick={() => onEdit(banner)}
          icon={Edit}
          customClassName="shadow-[0_0_10px_rgba(0,0,0,0.25)]"
        />
      </div>

      <div className="relative h-44 w-full overflow-hidden">
        <img
          src={process.env.REACT_APP_File_URL + banner.desktop_cover_image}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
          style={{
            clipPath: "polygon(0 0, 100% 100%, 0 100%)",
          }}
        />

        <img
          src={process.env.REACT_APP_File_URL + banner.phone_cover_image}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 100%)",
          }}
        />

        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background: "rgba(255,255,255,0.9)",
            clipPath:
              "polygon(0 0, 1.5% 0, 100% 98.5%, 100% 100%, 98.5% 100%, 0 1.5%)",
          }}
        />
      </div>

      <div className="h-20 bg-white flex items-start px-2 py-2">
        <h3
          className="
            relative pr-3 line-clamp-2 text-gray-600 font-medium text-base leading-7
            before:absolute before:right-0 before:top-2 before:h-4 before:w-1 before:rounded before:bg-primaryVar-500
          "
        >
          {banner.title}
        </h3>
      </div>

    </div>
  );
};